import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const startConversation = (payload) => {
  return Api(endPoints.startConversation, payload, requestType.POST);
};

const getConversationByCompanyId = (id) => {
  return Api(
    `${endPoints.getConversationByCompanyId}/${id}`,
    null,
    requestType.GET
  );
};

const getSingleConversationWithAdmin = (id, role) => {
  return Api(
    `${endPoints.getSingleConversationWithAdmin}/${id}?role=${role}`,
    null,
    requestType.GET
  );
};

const getAllConversationOfCompanyWithWorker = (id) => {
  return Api(
    `${endPoints.getAllConversationOfCompanyWithWorker}/${id}`,
    null,
    requestType.GET
  );
};

const getSingleCoversationOfWorkerWithCompany = (
  firstId,
  secondId,
  firstRole,
  secondRole
) => {
  return Api(
    `${endPoints.getSingleCoversationOfWorkerWithCompany}/${firstId}/${secondId}?firstRole=${firstRole}&secondRole=${secondRole}`,
    null,
    requestType.GET
  );
};

const getAllChatsByConversationId = (id, params) => {
  return Api(
    `${endPoints.getAllChatsByConversationId}/${id}`,
    params,
    requestType.GET
  );
};

const getConversationWorkerWithUser = (id) => {
  return Api(
    `${endPoints.getConversationWorkerWithUser}/${id}`,
    null,
    requestType.GET
  );
};

const getAppointmentChat = (id) => {
  return Api(`${endPoints.getAppointmentChat}/${id}`, null, requestType.GET);
};

export {
  startConversation,
  getConversationByCompanyId,
  getSingleConversationWithAdmin,
  getAllConversationOfCompanyWithWorker,
  getSingleCoversationOfWorkerWithCompany,
  getAllChatsByConversationId,
  getConversationWorkerWithUser,
  getAppointmentChat
};
